// extracted by mini-css-extract-plugin
module.exports = {"container":"viewScreenshotModal_container__3FOG5"};